// configuration available app wide
// PLEASE KEEP IN ALPHABETICAL ORDER
export const notifications = {
  acquisition: {
    create: {
      error: 'Unable to create acquisition.',
      duplicate: 'Acquisition label already exists in the session.',
    },
    delete: {
      success: 'Successfully removed acquisition(s).',
      error: 'Unable to remove acquisition(s).',
      analysisConflict: 'Unable to delete the acquisition because a file is used as an analysis input.',
      originalData: 'Unable to delete the aquisition because it contains original data.',
    },
    removeFile: {
      success: 'Successfully removed file.',
      error: 'Unable to remove file. Please try again later.',
      analysisConflict: 'The selected file is used as an analysis input and cannot be deleted.',
    },
    rename: {
      error: 'Unable to rename acquisition.',
    },
    copyFile: {
      success: 'Copied to clipboard successfully.',
    },
    updateFileInfo: {
      success: 'Successfully updated file information.',
      error: 'Unable to update file information. Please try again later.',
      errorEmptyKey: 'Unable to successfully save file. Custom information keys cannot be empty.',
    },
    updateInfo: {
      success: 'Successfully updated information.',
      error: 'Unable to update information. Please try again later.',
      errorEmptyKey: 'Unable to successfully save acquisition. Custom information keys cannot be empty.',
    },
  },
  analysis: {
    update: {
      success: 'Analysis successfully updated.',
      error: 'Analysis could not be updated.',
    },
    delete: {
      success: 'Analysis successfully deleted.',
      analysisConflictError:
        'Unable to delete analysis container because another analysis container is dependent on it.',
      error: 'Analysis could not be deleted.',
    },
    saveInfo: {
      success: 'Custom information successfully saved.',
      error: 'Unable to save custom information. Please try again later.',
    },
  },
  auditTrail: {
    cancel: {
      success: 'Audit trail report sucessfully cancelled.',
      error: 'Audit trail report could not be cancelled.',
    },
    create: {
      success: 'Audit trail report sucessfully created.',
      error: 'Audit trail report could not be created.',
      errorNameConflict: 'Label is already in use in this project.',
    },
    download: {
      success: 'Audit trail report sucessfully downloaded.',
      error: 'Audit trail report could not be downloaded.',
    },
    load: {
      error: 'Unable to load Audit trail reports.',
    },
  },
  collection: {
    fetchCollection: {
      error: 'Unable to fetch collection',
    },
    removeSessions: {
      success: 'Sessions successfully removed.',
      error: 'Unable to remove sessions. Please try again later.',
    },
  },
  collectionsAdmin: {
    query: {
      error: 'An error occurred while fetching collection.',
    },
    createNew: {
      success: 'Collection successfully created.',
      error: 'Unable to create collection. Please try again later.',
    },
    addToCollection: {
      success: 'Selection successfully added to collection.',
      error: 'Unable to add to collection. Please try again later.',
    },
    delete: {
      success: 'Collection successfully deleted.',
      error: 'Unable to delete collection. Please try again later.',
    },
    changeName: {
      success: 'Collection renamed successfully.',
      error: 'Unable to rename collection, please try again later.',
    },
    deleteAttachment: {
      success: 'Collection attachment successfully deleted.',
      error: 'Unable to delete collection attachment. Please try again later.',
    },
    addUser: {
      success: 'User added successfully.',
      error: 'Unable to add user. Please try again later.',
    },
    modifyUser: {
      success: 'Role changes saved successfully.',
      error: 'Unable to save role changes. Please try again later.',
    },
    removeUser: {
      success: 'User removed successfully.',
      error: 'Unable to remove user. Please try again later.',
    },
    updateDescription: {
      success: 'Project description successfully updated.',
      error: 'Unable to update description, please try again later.',
    },
    addNote: {
      success: 'Note saved successfully.',
      error: 'Unable to add note. Please try again later.',
    },
    removeNote: {
      success: 'Note successfully removed.',
      error: 'Unable to remove note. Please try again later.',
    },
    updateNote: {
      success: 'Note successfully updated.',
      error: 'Unable to update note. Please try again later.',
    },
  },
  common: {
    badRequest: 'The request was invalid or cannot be served',
    conflict: 'There was a conflict with the current state of the resource',
    delete: {
      success: 'Successfully deleted',
      error: 'An error occurred while deleting',
    },
    forbidden: 'Access is forbidden',
    notFound: 'The requested resource was not found',
    save: {
      success: 'Saved successfully',
      error: 'An error occurred while saving',
    },
    serverError: 'An internal server error occurred',
    serviceUnavailable: 'The service is temporarily unavailable',
    somethingWentWrong: 'Something went wrong',
    tooManyRequests: 'Too many requests. Please try again later',
    unauthorized: 'You are not authorized to perform this action',
    unprocessable: 'The request was well-formed but could not be processed',
  },
  container: {
    file: {
      delete: {
        success: 'File successfully deleted.',
        error: 'File could not be deleted.',
        analysis_conflict: 'File could not be deleted because it is used as analysis input.',
      },
      download: {
        error: 'File could not be downloaded.',
      },
      parse: {
        error: 'File could not be parsed.',
      },
      upload: {
        success: 'File successfully uploaded.',
        error: 'File could not be uploaded.',
      },
    },
    info: {
      update: {
        success: 'Information successfully updated.',
        error: 'Information could not be updated.',
        errorEmptyKey: 'Custom information keys cannot be empty.',
      },
    },
    note: {
      add: {
        success: 'Note successfully saved.',
        error: 'Note could not be saved.',
      },
      delete: {
        success: 'Note successfully deleted.',
        error: 'Note could not be deleted.',
      },
    },
  },
  cvatSettings: {
    save: {
      success: 'CVAT project settings updated',
      error: 'failed to update CVAT project settings',
    },
    enableUser: {
      success: 'User has been enabled.',
      error: 'User could not be enabled.',
    },
    addPermissions: {
      success: 'Permissions added successfully.',
      error: 'Unable to add permissions.',
    },
    updatePermissions: {
      success: 'Permissions updated successfully.',
      error: 'Unable to update permissions.',
    },
    updateStaffingPools: {
      error: 'Unable to update staffing pools.',
    },
    removePermissions: {
      success: 'Permissions removed successfully.',
      error: 'Unable to remove permissions.',
    },
    assignProject: {
      success: 'Project assigned successfully.',
      error: 'Unable to assign project.',
    },
    changeProjectRole: {
      success: 'Role updated successfully.',
      error: 'Unable to update role.',
    },
    removeProject: {
      success: 'Role removed successfully.',
      error: 'Unable to remove role.',
    },
    assignGroup: {
      success: 'Group assigned successfully.',
      error: 'Unable to assign group.',
    },
    changeGroupRole: {
      success: 'Role updated successfully.',
      error: 'Unable to update role.',
    },
    removeGroup: {
      success: 'Role removed successfully.',
      error: 'Unable to remove role.',
    },
  },
  dataexplorer: {
    advancedQuery: {
      error: 'There was an error performing your search. Check your query and try again.',
    },
    searchStatus: {
      indexing:
        "Search results are currently being indexed. You may not find what you're looking for until indexing is complete.",
    },
    saveTrainingSet: {
      error: 'Unable to create the training set. Please try another configuration.',
      success: 'Training set successfully created.',
    },
  },
  dependentProjects: {
    load: {
      error: 'Unable to load dependent projects.',
    },
  },
  device: {
    add: {
      error: 'Unable to add a new device.',
      success: 'Successfully added a new device.',
    },
    update: {
      error: 'Device could not be updated.',
    },
    disable: {
      error: 'Device could not be disabled.',
      success: 'Successfully disabled device.',
    },
    enable: {
      error: 'Device could not be enabled.',
      success: 'Successfully enabled device.',
    },
    key: {
      generation: {
        error: 'Unable to generate a new device key.',
      },
    },
  },
  dicom: {
    deid: {
      log: {
        error: 'Unable to log de-identified data.',
      },
      setProfile: {
        success: 'Successfully saved de-identification profile.',
        error: 'Unable to save de-identification profile. Please try again later.',
      },
      deleteProfile: {
        success: 'Successfully deleted de-identification profile.',
        error: 'Unable to delete de-identification profile. Please try again later.',
      },
    },
  },
  dimse: {
    peer: {
      add: {
        error: 'Unable to register peer. Please ensure inputs are valid.',
        success: 'Peer successfully added.',
      },
      delete: {
        error: 'Unable to delete peer.',
        success: 'Peer successfully deleted.',
      },
    },
    service: {
      enable: {
        success: 'Successfully enabled DIMSE Service',
        error: 'Unable to enable DIMSE Service',
      },
      disable: {
        success: 'Successfully disabled DIMSE Service',
        error: 'Unable to disable DIMSE Service',
      },
      rename: {
        success: 'Successfully renamed DIMSE Service',
        error: 'Unable to rename DIMSE Service',
      },
    },
  },
  download: {
    analyses: {
      error: 'Analyses could not be downloaded.',
    },
    files: {
      error: 'Files could not be downloaded.',
    },
    project: {
      error: 'Project could not be downloaded.',
    },
    sessions: {
      error: 'Sessions could not be downloaded.',
    },
  },
  externalRoutingId: {
    save: {
      success: 'External Routing ID saved successfully',
      error: 'Could not save External Routing ID',
    },
  },
  files: {
    changeType: {
      error: 'File type could not be changed.',
    },
    deleteVersion: {
      error: 'File version could not be deleted.',
      analysisConflict: 'File version could not be deleted because it is used as analysis input.',
    },
    move: {
      success: 'Files were moved successfully.',
      error: 'Unable to move files.',
      partialError: 'Some files in the selection could not be moved.',
      permission: 'You do not have permission to move files in this project.',
      rename: 'Some files must be renamed before they can be moved.',
      newAcquisition: 'Files were moved into a new acquisition.',
    },
    rename: {
      error: 'Unable to rename files.',
    },
    restoreVersion: {
      error: 'File version could not be restored.',
    },
    updateMetadata: {
      error: 'Unable to save file changes.',
    },
  },
  gearAccess: {
    update: {
      error: 'Unable to save gear access configuration.',
      success: 'Gear access successfully saved.',
    },
  },
  gearRules: {
    fixedInput: {
      warning: 'The current selected gear requires multiple file inputs. All but one input file must be fixed.',
    },
    save: {
      warning: 'Gear rule is disabled if no permissions are provided for the gear.',
    },
  },
  generateApiKey: {
    submit: {
      duplicate: 'API key label already exists.',
      error: 'Unable to generate a new API key.',
    },
  },
  groupsAdmin: {
    createNew: {
      success: 'Group created successfully.',
      duplicate: 'A group with this ID already exists in the site. Please choose a different group ID.',
      error: 'Unable to create group. Please try again later.',
    },
    changeName: {
      success: 'Group renamed successfully.',
      error: 'Unable to rename group, please try again later.',
    },
    delete: {
      success: 'Group successfully deleted.',
      error: 'Unable to delete collection. Please try again later.',
    },
    createNewTag: {
      success: 'Tag created successfully.',
      error: 'Unable to create tag. Please try again later.',
    },
    removeTag: {
      success: 'Tag removed successfully.',
      error: 'Unable to remove tag. Please try again later.',
    },
    changeTag: {
      success: 'Tag renamed successfully.',
      error: 'Unable to rename tag, please try again later.',
    },
    addUser: {
      success: 'User added successfully.',
      error: 'Unable to add user. Please try again later.',
    },
    updateUser: {
      success: 'Role changes saved successfully.',
      error: 'Unable to save role changes. Please try again later.',
    },
    removeUser: {
      success: 'User removed successfully.',
      error: 'Unable to remove user. Please try again later.',
    },
  },
  installedGears: {
    load: {
      error: 'Unable to load installed gears.',
    },
  },
  jobs: {
    add: {
      success: 'Job successfully queued.',
      error: 'Unable to queue job. Please try again later.',
    },
    cancel: {
      success: 'Job successfully cancelled.',
      error: 'Unable to cancel job. Please try again later.',
    },
    retry: {
      success: 'Job successfully retried.',
      error: 'Unable to retry job. Please try again later.',
    },
    updatePriority: {
      success: 'Job priority successfully updated.',
      error: 'Unable to update job priority. Please try again later.',
    },
    invalidJob: 'The specified job does not exist.',
  },
  ldap: {
    service: {
      enable: {
        success: 'Successfully added AD Group',
        error: 'Unable to add AD Group',
      },
      disable: {
        success: 'Successfully removed AD Group',
        error: 'Unable to remove AD Group',
      },
    },
  },
  modifyTagsDialog: {
    removeBulkTags: {
      success: 'Tags removed successfully.',
      error: 'Unable to remove tags. Please try again later.',
    },
    addBulkTags: {
      success: 'Tags added successfully.',
      error: 'Unable to add tags. Please try again later.',
    },
  },
  operationsStorageSelect: {
    notifications: {
      failedToGetPermissions: 'Permission check failed. Unable to fetch storage options.',
      failedToGetStorages: 'Unable to fetch storage options.',
      tryLater: 'Cannot fetch storage providers right now. Please try again later.',
    },
  },
  permissions: {
    check: {
      error: 'Unable to verify permissions. Please try again later.',
    },
  },
  project: {
    fetch: {
      error: 'Unable to fetch project.',
    },
    permissions: {
      check: {
        error: 'There was an error fetching permissions for project(s).',
      },
    },
  },
  projectAdmin: {
    createNew: {
      success: 'Project successfully created.',
      error: 'Unable to create project. Please try again later.',
    },
    delete: {
      success: 'Project successfully deleted.',
      error: 'Unable to delete project. Please try again later.',
    },
    updateLabel: {
      success: 'Project renamed successfully.',
      error: 'Unable to rename project, please try again later.',
      duplicate: 'Project label already exists in the group.',
    },
    updateDescription: {
      success: 'Project description successfully updated.',
      error: 'Unable to update description, please try again later.',
    },
    updateCustomInfo: {
      success: 'Project information successfully updated.',
      error: 'Unable to update information, please try again later.',
    },
    deleteAttachment: {
      success: 'Project attachment successfully deleted.',
      error: 'Unable to delete project attachment. Please try again later.',
    },
    addUser: {
      success: 'User added successfully.',
      error: 'Unable to add user. Please try again later.',
    },
    modifyUser: {
      success: 'Role changes saved successfully.',
      error: 'Unable to save role changes.',
    },
    removeUser: {
      success: 'User removed successfully.',
      error: 'Unable to remove user. Please try again later.',
    },
    validateTemplate: {
      error: 'Unable to update template, please check your template form.',
    },
    updateTemplate: {
      success: 'Template updated successfully.',
      error: 'Unable to update template. Please try again later.',
    },
    removeTemplate: {
      success: 'Template removed successfully.',
      error: 'Unable to remove template. Please try again later.',
    },
    addNote: {
      success: 'Note saved successfully.',
      error: 'Unable to add note. Please try again later.',
    },
    removeNote: {
      success: 'Note successfully removed.',
      error: 'Unable to remove note. Please try again later.',
    },
    updateNote: {
      success: 'Note successfully updated.',
      error: 'Unable to update note. Please try again later.',
    },
  },
  projectCopy: {
    success: 'Project is in the process of being copied.',
    error: 'Unable to copy project.',
  },
  projectExport: {
    dryRun: {
      cancel: {
        error: 'Unable to cancel dry-run project export.',
        success: 'Project export dry-run successfully cancelled.',
      },
    },
    list: {
      error: 'Failed to fetch export jobs.',
    },
  },
  projectImport: {
    cancel: {
      error: 'Unable to cancel project import.',
      success: 'Project import successfully cancelled.',
    },
    conflicts: {
      error: 'Unable to fetch import conflicts.',
    },
    conflictReport: {
      error: 'Unable to generate conflict report.',
      timeout: 'Conflict report was not generated in time.',
    },
    create: {
      error: 'Unable to create import.',
      success: 'Project import successfully started.',
    },
    list: {
      error: 'Failed to fetch import jobs.',
    },
    processFiles: {
      error: 'There was an error processing files.',
    },
    storages: {
      error: 'Unabled to fetch storages.',
    },
    rerun: {
      error: 'Unable to rerun project import.',
      success: 'Project import successfully started.',
    },
  },
  projectReport: {
    generateReportError: 'An error occured generating the report.',
  },
  projectSharing: {
    copies: {
      error: "There was an error fetching project's dependents (copies).",
    },
    settings: {
      save: {
        success: 'Project settings successfully saved.',
        error: 'Unable to save project settings.',
      },
    },
  },
  projects: {
    load: {
      error: 'Unable to load projects',
    },
  },
  profile: {
    changeAvatar: {
      success: 'Avatar updated successfully.',
      error: 'Unable to update avatar. Please try again later.',
    },
    updateInfo: {
      success: 'Profile saved successfully.',
      error: 'Unable to save profile. Please try again later.',
    },
    updatePreferences: {
      error: 'Unable to save user preferences. Please try again later.',
    },
  },
  forms: {
    archive: {
      error: 'Unable to archive form.',
      success: 'Form successfully archived.',
    },
    create: {
      error: 'Unable to create form.',
      success: 'Form successfully created.',
    },
    copy: {
      error: 'Unable to copy form.',
      success: 'Form successfully copied.',
    },
    delete: {
      error: 'Unable to delete draft form.',
      success: 'Draft form successfully deleted.',
    },
    notes: {
      error: 'Unable to save notes.',
      success: 'Notes successfully saved.',
    },
    publish: {
      error: 'Unable to publish form.',
      success: 'Form successfully published.',
    },
    query: {
      error: 'Unable to fetch forms.',
    },
    restore: {
      error: 'Unable to restore form.',
      success: 'Form successfully restored.',
    },
    save: {
      error: 'Unable to save form.',
      invalidSchema: 'Form has validation errors. Fix all errors before saving.',
    },
    draft: {
      error: 'Unable to draft a new version of the form.',
    },
  },
  protocols: {
    archive: {
      error: 'Unable to archive protocol.',
      success: 'Protocol successfully archived.',
    },
    create: {
      error: 'Unable to create protocol.',
      success: 'Protocol successfully created.',
    },
    copy: {
      error: 'Unable to copy protocol.',
      success: 'Protocol successfully copied.',
    },
    delete: {
      error: 'Unable to delete draft protocol.',
    },
    edit: {
      success: 'Protocol successfully updated.',
    },
    notes: {
      error: 'Unable to save notes.',
      success: 'Notes successfully saved.',
    },
    publish: {
      error: 'Unable to publish protocol.',
      success: 'Protocol successfully published.',
    },
    query: {
      error: 'Unabled to fetch protocols.',
    },
    restore: {
      error: 'Unable to restore protocol.',
      success: 'Protocol successfully restored.',
    },
    save: {
      error: 'Unable to save protocol.',
    },
    draft: {
      error: 'Unable to draft a new version of the protocol.',
    },
  },
  roles: {
    create: {
      success: 'Role added successfully.',
      error: 'Role could not be added.',
    },
    delete: {
      success: 'Role removed successfully.',
      error: 'Role could not be removed.',
    },
    update: {
      success: 'Role saved successfully.',
      error: 'Role could not be saved.',
    },
    groupRoles: {
      update: {
        success: 'Role groups updated successfully.',
        error: 'Role groups could not be updated.',
      },
      post: {
        success: 'Role successfully added to group permissions.',
        error: 'Role could not be added to group permissions.',
      },
      delete: {
        success: 'Role successfully removed from group permissions.',
        error: 'Role could not be removed from group permissions.',
      },
    },
  },
  rules: {
    addRule: {
      success: 'Rule added successfully.',
      error: 'Unable to add rule. Please try again later.',
      missingCriteria: 'At least one critera is required before saving a rule.',
      missingFixedInputs: 'All but one input file must be fixed.',
    },
    removeRule: {
      success: 'Rule removed successfully.',
      error: 'Unable to remove rule. Please try again later.',
    },
    enableRule: {
      error: 'Rule could not be enabled.',
    },
    disableRule: {
      error: 'Rule could not be disabled.',
    },
  },
  queriesDialog: {
    query: {
      error: 'Unabled to fetch changes.',
    },
  },
  session: {
    query: {
      error: 'An error occurred while fetching sessions.',
    },
    add: {
      success: 'Session added successfully.',
      error: 'Unable to successfully add session. Please try again later.',
    },
    addTag: {
      success: 'Tag added successfully.',
      error: 'Unable to successfully add tag. Please try again later.',
    },
    delete: {
      success: 'Session(s) successfully deleted.',
      error: 'Unable to delete session(s). Please try again later.',
      originalData: 'Unable to delete the session because it contains original data.',
      analysisConflict: 'Unable to delete the session because a file is used as an analysis input.',
    },
    deleteTag: {
      success: 'Tag successfully deleted.',
      error: 'Unable to delete tag. Please try again later.',
    },
    saveProject: {
      success: 'Project saved successfully.',
      error: 'Unable to successfully save project. Please try again later.',
      errorEmptyKey: 'Unable to successfully save project. Custom information keys cannot be empty.',
    },
    saveSession: {
      success: 'Session saved successfully.',
      error: 'Unable to successfully save session. Please try again later.',
      errorEmptyKey: 'Unable to successfully save session. Custom information keys cannot be empty.',
    },
    addSubject: {
      success: 'Subject successfully created.',
      error: 'Unable to create subject. Please try again later.',
      duplicate: 'Subject label already exists in this project. Use another label.',
    },
    deleteSubject: {
      success: 'Subject successfully deleted.',
      error: 'Unable to delete subject. Please try again later.',
      originalData: 'Unable to delete the subject because it contains original data.',
      analysisConflict: 'Unable to delete the subject because a file is used as an analysis input.',
    },
    saveSubject: {
      success: 'Subject saved successfully.',
      error: 'Unable to successfully save subject. Please try again later.',
      errorDuplicateCode:
        'This subject already exists please use a unique subject label. To change a session to an existing subject please use the action "move sessions to subject".',
      errorCustomInfo: 'Unable to successfully save subject custom information. Please try again later.',
      errorEmptyKey: 'Unable to successfully save subject custom information. Custom information keys cannot be empty.',
    },
    deleteProjectAttachment: {
      success: 'Project attachment successfully deleted.',
      error: 'Unable to delete project attachment. Please try again later.',
    },
    addNote: {
      success: 'Note saved successfully.',
      error: 'Unable to add note. Please try again later.',
    },
    deleteNote: {
      success: 'Note successfully deleted.',
      error: 'Unable to remove note. Please try again later.',
    },
    addACQtoCollection: {
      success: 'Acquisitions successfully added to collection.',
      error: 'Unable to add acquisitions to collection. Please try again later.',
    },
    addSessionsToCollection: {
      success: 'Sessions successfully added to collection.',
      error: 'Unable to add sessions to collection. Please try again later.',
    },
    moveSessionsToProject: {
      success: 'Sessions successfully moved to project.',
      error: 'Unable to move sessions. Please try again later.',
      noop: 'No sessions were moved.',
    },
    moveSessionsToSubject: {
      success: 'Sessions successfully moved to subject.',
    },
    moveAcquisitionToSession: {
      dryError: 'Unable to check for conflicts in destination.',
      success: 'Acquisitions sucessfully moved to session.',
      error: 'Unable to move acquisitions',
      sourceDelete: {
        success: 'Empty source session deleted.',
        error: 'Unable to delete empty source session.',
      },
    },
    deleteAnalysis: {
      success: 'Analysis successfully deleted.',
      error: 'Unable to remove analysis. Please try again later.',
    },
    saveAnalysis: {
      success: 'Analysis saved successfully.',
      error: 'Unable to save analysis. Please try again later.',
      errorEmptyKey: 'Unable to save analysis.  Custom information keys cannot be empty.',
    },
  },
  siteSettings: {
    update: {
      success: 'Site settings successfully saved.',
      error: 'Unable to save site settings.',
    },
    mfa: {
      success: 'MFA Channels saved successfully.',
      failure: 'Something went wrong, MFA channels could not be saved.',
    },
  },
  staffingPools: {
    get: {
      error: 'There was an error loading Staffing Pools',
    },
    addUsers: {
      success: 'Successfully added users',
      error: 'Failed to add users',
    },
    create: {
      success: 'Staffing pool created successfully',
      error: 'Failed to create a staffing pool',
    },
    edit: {
      success: 'Staffing pool updated successfully',
      error: 'Failed to update staffing pool',
    },
  },
  subject: {
    query: {
      error: 'An error occurred while fetching subjects.',
    },
    merge: {
      error:
        'This subject already exists and cannot be overwritten. Create a new subject or use the move session to subject workflow.',
    },
  },
  tag: {
    add: {
      success: 'Tag successfully saved.',
      error: 'Tag could not be saved.',
    },
    delete: {
      success: 'Tag successfully deleted.',
      error: 'Tag could not be deleted.',
    },
  },
  tasks: {
    get: {
      error: 'There was an error loading tasks.',
    },
    update: {
      success: 'Updated successfully.',
      error: 'Failed to update task.',
    },
    clone: {
      success: 'Task successfully cloned.',
      error: 'Failed to clone task.',
    },
    bulkCreate: {
      createAllSuccess: 'Tasks and selected duplicates successfully created.',
      createCleanSuccess: 'Tasks successfully created without duplication.',
      ignoreDuplicatesSuccess: 'Bulk tasks created successfully and all duplicates ignored.',
      noneCreated: 'No task(s) created',
      error: 'Unable to create task(s).',
    },
    cloneCreate: {
      success: 'Task successfully cloned.',
      error: 'Unable to clone task.',
    },
    create: {
      success: 'Reader tasks successfully created.',
      error: 'Unable to create reader task.',
      adjudicationBulkSuccess: 'Reader and Adjudicator Tasks successfully created',
      adjudicationError: 'Unable to create reader tasks.',
    },
    complete: {
      success: 'Adjudication task completed successfully.',
      error: 'Failed to complete adjudication task. Please try again.',
    },
    taskEdit: {
      success: 'Task successfully saved.',
      error: 'Unable to save task.',
    },
    fetchTaskDetails: {
      error: 'Unable to fetch task form and annotation data.',
    },
    delete: {
      error: 'There was an error deleting task(s).',
      success: 'Task(s) successfully deleted.',
    },
    deleteOne: {
      error: 'There was an error deleting the task.',
      success: 'Task successfully deleted.',
    },
    launch: {
      multiTask: {
        error: 'Could not launch a viewer as the selected tasks are targeted for multiple viewers.',
      },
      v3MultiTask: {
        error: 'OHIF v3 viewer does not support launching multiple tasks together.',
      },
    },
    queue: {
      protocols: {
        error: 'Failed to fetch protocols',
      },
      create: {
        success: 'Task report created successfully.',
        error: 'Failed to create task report.',
      },
      delete: {
        success: 'Successfully deleted task report.',
        error: 'Unable to delete task report.',
      },
      download: {
        success: 'Task successfully downloaded.',
        error: 'There was an error downloading task.',
      },
    },
  },
  tasksFilter: {
    get: {
      success: 'Task filters successfully loaded.',
      error: 'There was an error loading task filters.',
    },
    edit: {
      success: 'Task filter successfully updated.',
      error: 'There was an error updating task filter.',
    },
    save: {
      success: 'Task filter successfully saved.',
      error: 'There was an error saving task filter.',
    },
    delete: {
      success: 'Task filter successfully deleted.',
      error: 'There was an error deleting task filter.',
    },
  },
  taskDetails: {
    update: {
      statusChanged: 'Task status has changed. Refreshing with the latest data.',
      fields: {
        error: 'Failed to update task fields. Please try again.',
      },
      assignee: {
        error: 'Failed to update assignee. Please try again.',
      },
    },
  },
  userManagement: {
    createNew: {
      success: 'User created successfully.',
      error: 'Unable to create user.',
      conflict: 'A user associated with that email address already exists.',
    },
    updateInfo: {
      success: 'User information saved successfully.',
      error: 'Unable to save user information.',
    },
    disableUser: {
      success: 'User has been disabled.',
      error: 'User could not be disabled.',
    },
    updateStaffingPools: {
      error: 'Unable to update staffing pools.',
    },
    staffingPoolsAddUsers: {
      success: 'Users added to staffing pool successfully',
      error: 'Failed to add users to staffing pool',
    },
    staffingPoolsRemoveUsers: {
      success: 'Users removed from staffing pool successfully',
      error: 'Failed to remove users from staffing pool',
    },
    deleteStaffingPool: {
      success: 'Staffing pool deleted successfully',
      error: 'Failed to delete staffing pool',
    },
    enableUser: {
      success: 'User has been enabled.',
      error: 'User could not be enabled.',
    },
  },
  users: {
    load: {
      error: 'Unable to load users',
    },
  },
  views: {
    definition: {
      error: 'Failed to retrieve data view definition.',
    },
    create: {
      success: 'View successfully created.',
      error: 'Data view could not be saved.',
    },
    delete: {
      success: 'View successfully deleted.',
      error: 'Data view could not be deleted.',
    },
    edit: {
      warning: {
        compatibleContainerType:
          'Data view file specs container type has been updated to match the lowest hierarchical container type from selected columns.',
      },
    },
    load: {
      error: 'There was an error loading data views.',
    },
    executions: {
      data: {
        error: 'View execution has failed.',
      },
      get: {
        error: 'Failed to get data view execution.',
        executions: {
          error: 'There was an error fetching data view executions.',
        },
      },
      save: {
        error: 'Failed to saved data view execution.',
        success: 'View execution successfully saved to project.',
      },
      state: {
        error: 'Data view execution failed.',
      },
    },
    export: {
      error: 'Data view could not be exported.',
    },
    fetch: {
      error: 'Failure retreiving view data',
    },
    update: {
      success: 'View successfully updated.',
      error: 'Data view could not be saved.',
    },
    preview: {
      error: 'Preview could not be displayed.',
    },
    promote: {
      success: 'View successfully added to sitewide templates',
      error: 'View could not be added to sitewide templates.',
    },
    templates: {
      create: {
        success: 'Template successfully created.',
        error: 'Template could not be saved.',
      },
      delete: {
        success: 'Template successfully deleted.',
        error: 'Template could not be deleted.',
      },
      update: {
        success: 'Template successfully updated.',
        error: 'Template could not be saved.',
      },
    },
    queue: {
      success: 'Data view execution successfully queued.',
      error: 'Failed to queue data view execution.',
    },
  },
  viewerApplications: {
    edit: {
      success: 'Viewer Application successfully edited',
      error: 'Viewer Application could not be edited',
    },
    register: {
      success: 'Viewer Application successfully registered',
      error: 'Viewer Application could not be registered',
    },
    remove: {
      success: 'Viewer Application successfully removed',
      error: 'Viewer Application could not be removed',
    },
    reorder: {
      success: 'Viewer Application successfully saved',
      error: 'Viewer Application could not be saved',
    },
  },
  viewerProtocols: {
    create: {
      success: 'Viewer Protocol successfully created',
      error: 'Viewer Protocol could not be created',
    },
    edit: {
      success: 'Viewer Protocol successfully saved',
      error: 'Viewer Protocol could not be saved',
    },
    duplicate: {
      success: 'Viewer Protocol successfully duplicated',
      error: 'Viewer Protocol could not be duplicated',
    },
    delete: {
      success: 'Viewer Protocol successfully deleted',
      error: 'Viewer Protocol could not be deleted',
    },
    formUpload: {
      success: 'Viewer Form successfully uploaded',
      error: 'Viewer Form could not be uploaded',
      errorJSON: 'Viewer Form is not valid JSON',
      errorValidation: 'Viewer Form is not valid',
    },
    viewerConfigUpload: {
      success: 'Viewer Config successfully uploaded',
      error: 'Viewer Config could not be uploaded',
      errorJSON: 'Viewer Config is not valid JSON',
      errorValidation: 'Viewer Config is not valid',
    },
  },
  viewerService: {
    restore: {
      error: 'The requested Extension Application cannot be launched. Ensure the browser URL is valid, and try again.',
    },
  },
  workspaces: {
    jupyterhub: {
      create: {
        success: 'JupyterLab Server sucessfully created.',
        error: 'JupyterLab Server could not be created.',
      },
      delete: {
        success: 'JupyterLab Server sucessfully deleted.',
        error: 'JupyterLab Server could not be deleted.',
      },
      download: {
        error: 'JupyterLab Notebook could not be downloaded.',
      },
      edit: {
        success: 'JupyterLab Server sucessfully edited.',
        error: 'JupyterLab Server could not be edited.',
      },
      load: {
        error: 'Unable to load JupyterLab servers.',
      },
      start: {
        success: 'JupyterLab Server sucessfully started.',
        error: 'JupyterLab Server could not be started.',
      },
      stop: {
        success: 'JupyterLab Server sucessfully stopped',
        error: 'JupyterLab Server could not be stopped',
      },
    },
    settings: {
      jupyterhub: {
        enable: {
          success: 'Jupyter Workspace has been successfully enabled.',
          error: 'Unable to enable Jupyter Workspace.',
        },
        disable: {
          success: 'Jupyter Workspace has been successfully disabled.',
          error: 'Unable to disable Jupyter Workspace.',
        },
      },
    },
  },
  xfer: {
    storages: {
      get: {
        error: 'Unable to load external storages.',
      },
      create: {
        success: 'Storage created successfully.',
        error: 'Storage could not be created.',
      },
      modify: {
        success: 'Storage modified successfully.',
        error: 'Storage could not be modified.',
      },
      delete: {
        success: 'Storage deleted successfully.',
        error: 'Storage could not be deleted.',
      },
    },
  },
};
